import React, { useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { gettext } from "web/script/modules/django-i18n";
import { LanguageChoicePropType } from "web/types/language";
import { getURL } from "web/script/routing/getUrl";
import BurgerMenuItem from "../burger-menu-item/burger-menu-item";
import BurgerMenuSmallItem from "../burger-menu-small-item/burger-menu-small-item";
import BurgerMenuView from "../burger-menu-view/burger-menu-view";
import style from "./burger-menu-gender-menu.css";

function BurgerMenuGenderedMenu({
    currentCountry,
    currentCurrency,
    currentLanguage,
    menuData,
    onCategoryClick,
    onCountrySelectorClick,
    onLanguageSelectorClick,
    selectedGender,
    showCountryPicker,
    showLanguageSelector,
    updateGenderState,
    fullRender,
}) {
    const MEN_PAGE_INDEX = 1;
    const WOMEN_PAGE_INDEX = 0;

    const [genderMenuIndex, setGenderMenuIndex] = useState(getGenderIndex());

    function getGenderIndex() {
        return selectedGender === "Men" ? 1 : 0;
    }

    function onGenderClick(gender) {
        if (gender === "Men") {
            setGenderMenuIndex(MEN_PAGE_INDEX);
        } else {
            setGenderMenuIndex(WOMEN_PAGE_INDEX);
        }
        updateGenderState(gender);
    }

    function renderGenderSelector() {
        if (selectedGender) {
            return (
                <div className={style.genderSelector}>
                    <div
                        className={
                            selectedGender === "Women" ? style.genderActive : style.genderOption
                        }
                        onClick={() => onGenderClick("Women")}
                    >
                        {gettext("general.women")}
                    </div>
                    <div
                        className={
                            selectedGender === "Men" ? style.genderActive : style.genderOption
                        }
                        onClick={() => onGenderClick("Men")}
                    >
                        {gettext("general.men")}
                    </div>
                </div>
            );
        }
    }

    function menuCategoriesFullRender(menu) {
        return menu.menus.map((category) => {
            return (
                <>
                    <BurgerMenuItem
                        key={category.name + genderMenuIndex}
                        renderText={category.display_name || category.name}
                        renderChevron={true}
                        onClickEvent={() => onCategoryClick(category)}
                    />
                    <BurgerMenuView
                        key={category.display_name}
                        categories={[category]}
                        onCategoryClick={onCategoryClick}
                        onBackToMainClick={() => {}}
                        selectedCategory={menuData[genderMenuIndex]}
                    />
                </>
            );
        });
    }

    function menuCategories(genderedMenu) {
        return genderedMenu.menus.map((menu) => {
            return (
                <BurgerMenuItem
                    key={genderedMenu.name + "-" + menu.name}
                    renderText={menu.display_name || menu.name}
                    renderChevron={true}
                    onClickEvent={() => onCategoryClick(menu)}
                />
            );
        });
    }

    function menuLinks(genderedMenu) {
        return genderedMenu.links.map((link) => {
            return (
                <BurgerMenuItem
                    key={link.text || link.name}
                    renderText={link.text || link.name}
                    href={link.url}
                />
            );
        });
    }

    let genderMenus = menuData.map((genderedMenu) => {
        return (
            <ul key={genderedMenu.gender || genderedMenu.name} id="genderedMenuLinks">
                {fullRender ? menuCategoriesFullRender(genderedMenu) : menuCategories(genderedMenu)}

                {!fullRender && menuLinks(genderedMenu)}

                <BurgerMenuSmallItem
                    renderText={gettext("burger_menu.country_selector", {
                        country: currentCountry,
                        currency_indicator: currentCurrency,
                    })}
                    renderChevron={showCountryPicker}
                    onClickEvent={() => onCountrySelectorClick()}
                />
                {showLanguageSelector && (
                    <BurgerMenuSmallItem
                        renderText={gettext("burger_menu.language_selector", {
                            language: currentLanguage.language_name,
                        })}
                        renderChevron={true}
                        onClickEvent={() => onLanguageSelectorClick()}
                    />
                )}
                <BurgerMenuSmallItem
                    renderText={gettext("header.help.help_center")}
                    href={getURL("helpCentreHomepage")}
                />
                <BurgerMenuSmallItem
                    renderText={gettext("header.help.contact_us")}
                    href={getURL("helpContactUs")}
                />
                <BurgerMenuSmallItem
                    renderText={gettext("header.help.about_us")}
                    href={getURL("about")}
                />
                <BurgerMenuSmallItem
                    renderText={gettext("header.help.careers")}
                    href={getURL("careers")}
                />
            </ul>
        );
    });

    return (
        <div className={style.genderedMenu}>
            {renderGenderSelector()}
            <SwipeableViews disabled index={genderMenuIndex}>
                {genderMenus}
            </SwipeableViews>
        </div>
    );
}

export default BurgerMenuGenderedMenu;

BurgerMenuGenderedMenu.propTypes = {
    currentCountry: PropTypes.string,
    currentCurrency: PropTypes.string,
    currentLanguage: LanguageChoicePropType,
    menuData: PropTypes.array,
    onCategoryClick: PropTypes.func.isRequired,
    onCountrySelectorClick: PropTypes.func.isRequired,
    onLanguageSelectorClick: PropTypes.func.isRequired,
    selectedGender: PropTypes.string,
    showCountryPicker: PropTypes.bool,
    showLanguageSelector: PropTypes.bool,
    updateGenderState: PropTypes.func.isRequired,
    fullRender: PropTypes.bool,
};

BurgerMenuGenderedMenu.defaultProps = {
    currentCountry: "",
    currentCurrency: "",
    menuData: [],
    selectedGender: "",
    showCountryPicker: false,
    showLanguageSelector: false,
    fullRender: false,
};
